import { Pagination } from "@heroui/react";
import PropTypes from "prop-types";

export default function PaginateModal({
                                        links = [],
                                        currentPage = 1,
                                        onPageChangePage = () => {}
                                      }) {
  const getTotalPages = () => {
    try {
      if (!Array.isArray(links)) return 0;

      if (links.length < 3) return links.length;

      return links.slice(1, -1).length;
    } catch (error) {
      console.error("Error calculating total pages:", error);
      return 0;
    }
  };

  return (
    <div className="flex justify-center items-center mt-5 mb-5 rtl space-x-4">
      <Pagination
        initialPage={1}
        page={Number(currentPage) || 1}
        size={"lg"}
        total={getTotalPages()}
        onChange={(page) => {
          try {
            onPageChangePage(page);
          } catch (error) {
            console.error("Error in page change handler:", error);
          }
        }}
      />
    </div>
  );
}

PaginateModal.propTypes = {
  links: PropTypes.array,
  currentPage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  onPageChangePage: PropTypes.func,
};

PaginateModal.defaultProps = {
  links: [],
  currentPage: 1,
  onPageChangePage: () => {},
};